export var EntityCategory;
(function (EntityCategory) {
    EntityCategory["BILLING"] = "billing";
    EntityCategory["ERP"] = "erp";
    EntityCategory["PAYMENTS"] = "payments";
    EntityCategory["CRM"] = "crm";
    EntityCategory["TAX"] = "tax";
})(EntityCategory || (EntityCategory = {}));
export var EntityID;
(function (EntityID) {
    // Billing Entities
    EntityID["BILLING_ACCOUNT"] = "billing_account";
    EntityID["BILLING_CREDIT_MEMO"] = "billing_credit_memo";
    EntityID["BILLING_INVOICE"] = "billing_invoice";
    EntityID["BILLING_PAYMENT"] = "billing_payment";
    EntityID["BILLING_REFUND"] = "billing_refund";
    EntityID["BILLING_SUBSCRIPTION"] = "billing_subscription";
    EntityID["BILLING_USAGE"] = "billing_usage";
    // ERP Entities
    EntityID["ERP_ACCOUNT"] = "erp_account";
    EntityID["ERP_ACCOUNTING_BOOK"] = "erp_accounting_book";
    EntityID["ERP_BILL"] = "erp_bill";
    EntityID["ERP_BILL_CREDIT"] = "erp_bill_credit";
    EntityID["ERP_BILL_CREDIT_ITEM"] = "erp_bill_credit_item";
    EntityID["ERP_BILL_PAYMENT_ITEMS"] = "erp_bill_payment_items";
    EntityID["ERP_BILLING_SCHEDULE"] = "erp_billing_schedule";
    EntityID["ERP_CHECK"] = "erp_check";
    EntityID["ERP_CHEQUE"] = "erp_cheque";
    EntityID["ERP_CREDIT_MEMO"] = "erp_credit_memo";
    EntityID["ERP_CREDIT_MEMO_ITEMS"] = "erp_credit_memo_items";
    EntityID["ERP_CUSTOMER"] = "erp_customer";
    EntityID["ERP_DEPARTMENT"] = "erp_department";
    EntityID["ERP_DEPOSIT"] = "erp_deposit";
    EntityID["ERP_EMPLOYEE"] = "erp_employee";
    EntityID["ERP_ENTRIES"] = "erp_entries";
    EntityID["ERP_EXPENSE_REPORT"] = "erp_expense_report";
    EntityID["ERP_EXPENSE_REPORT_ITEMS"] = "erp_expense_report_items";
    EntityID["ERP_INVOICE"] = "erp_invoice";
    EntityID["ERP_INVOICE_ITEMS"] = "erp_invoice_items";
    EntityID["ERP_INVOICE_SHIPPING_ADDRESS"] = "erp_invoice_shipping_address";
    EntityID["ERP_ITEM_RECEIPT"] = "erp_item_receipt";
    EntityID["ERP_JOURNAL"] = "erp_journal";
    EntityID["ERP_JOURNAL_ITEMS"] = "erp_journal_items";
    EntityID["ERP_PAYMENT"] = "erp_payment";
    EntityID["ERP_PAYMENT_ITEMS"] = "erp_payment_items";
    EntityID["ERP_PRODUCT"] = "erp_product";
    EntityID["ERP_PURCHASE_ORDER"] = "erp_purchase_order";
    EntityID["ERP_PURCHASE"] = "erp_purchase";
    EntityID["ERP_REFUND"] = "erp_refund";
    EntityID["ERP_REFUND_ITEMS"] = "erp_refund_items";
    EntityID["ERP_SALES_ORDER"] = "erp_sales_order";
    EntityID["ERP_SALES_ORDER_ITEMS"] = "erp_sales_order_items";
    EntityID["ERP_TRANSFER"] = "erp_transfer";
    EntityID["ERP_VENDOR"] = "erp_vendor";
    // Payments Entities
    EntityID["PAYMENTS_CUSTOMER"] = "payments_customer";
    EntityID["PAYMENTS_PAYMENT"] = "payments_payment";
    EntityID["PAYMENTS_PAYOUT"] = "payments_payout";
    EntityID["PAYMENTS_REFUND"] = "payments_refund";
    EntityID["PAYMENTS_TRANSFER"] = "payments_transfer";
    // CRM Entities
    EntityID["CRM_ACCOUNT"] = "crm_account";
    EntityID["CRM_ASSET"] = "crm_asset";
    EntityID["CRM_ATTACHMENT"] = "crm_attachment";
    EntityID["CRM_CONTRACT"] = "crm_contract";
    EntityID["CRM_INSTALLMENT"] = "crm_installment";
    EntityID["CRM_INVOICE"] = "crm_invoice";
    EntityID["CRM_OPPORTUNITY"] = "crm_opportunity";
    EntityID["CRM_OPPORTUNITY_DOC"] = "crm_opportunity_doc";
    EntityID["CRM_OPPORTUNITY_ITEMS"] = "crm_opportunity_items";
    EntityID["CRM_MT_DOC"] = "crm_mt_doc";
    EntityID["CRM_MT_DOC_ITEMS"] = "crm_mt_doc_items";
    EntityID["CRM_OF_DOC"] = "crm_of_doc";
    EntityID["CRM_OF_DOC_ITEMS"] = "crm_of_doc_items";
    EntityID["CRM_PO_DOC"] = "crm_po_doc";
    EntityID["CRM_PO_DOC_ITEMS"] = "crm_po_doc_items";
    EntityID["CRM_SA_DOC"] = "crm_sa_doc";
    EntityID["CRM_TC_DOC"] = "crm_tc_doc";
    EntityID["CRM_PRICEBOOK"] = "crm_pricebook";
    EntityID["CRM_PRICEBOOK_ENTRY"] = "crm_pricebook_entry";
    EntityID["CRM_PRODUCT"] = "crm_product";
    EntityID["CRM_QUOTE"] = "crm_quote";
    // Tax Entities
    EntityID["TAX_CUSTOMER"] = "tax_customer";
    EntityID["TAX_INVOICE"] = "tax_invoice";
    EntityID["TAX_INVOICE_ITEMS"] = "tax_invoice_items";
})(EntityID || (EntityID = {}));
